import React from "react";
import { motion } from "framer-motion";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "../assets/css/Hero.css";
import "../assets/css/InsightPreviewer.css";
import igIcon from "../assets/img/platform/instagram.png";
import fbIcon from "../assets/img/platform/facebook.png";
import ytIcon from "../assets/img/platform/youtube.png";

const formatFollowers = (count) => {
  if (!count) return "0";
  if (count >= 1000000) return (count / 1000000).toFixed(1) + "M";
  if (count >= 1000) return (count / 1000).toFixed(1) + "K";
  return count;
};

// Converts **text** markdown into <strong> JSX elements
const parseBold = (str) => {
  if (!str) return null;
  const parts = str.split(/\*\*(.*?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part
  );
};

const renderInsightWithBlur = (text, index) => {
  // Split on both "**Target Action**:" and plain "Target Action:"
  const splitToken = text.includes("**Target Action**:")
    ? "**Target Action**:"
    : "Target Action:";
  const parts = text.split(splitToken);

  if (parts.length < 2) return (
    <div key={index} className="insight-bullet">
      <div className="insight-analysis">{parseBold(text)}</div>
    </div>
  );
  return (
    <div key={index} className="insight-bullet">
      <div className="insight-analysis">{parseBold(parts[0])}</div>
      <div className="insight-action">
        <strong>Target Action:</strong>{" "}
        {index === 0 ? (
          <span className="clear-action">{parseBold(parts[1])}</span>
        ) : (
          <span className="blurred-action">{parseBold(parts[1])}</span>
        )}
      </div>
    </div>
  );
};

const LiveDemoPromo = () => {
  const appFrontendUrl = process.env.REACT_APP_URL || "https://app.comparedly.com";

  return (
    <section id="live-demo-promo" style={{
      padding: "80px 20px",
      background: "linear-gradient(135deg, #f0fdfd 0%, #e0f7fa 100%)",
      textAlign: "center"
    }}>
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "2.5rem", fontWeight: "700", marginBottom: "16px", color: "#1a202c" }}>
            Not ready to sign up? <span style={{ color: "#00A1A1" }}>Try it instantly.</span>
          </h2>
          <p style={{ fontFamily: "'Lato', sans-serif", fontSize: "1.125rem", color: "#4a5568", marginBottom: "32px", lineHeight: "1.6" }}>
            Experience the full power of Comparedly with our pre-populated live environment.
            <br />No registration, no credit card, just instant insights.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "24px", marginBottom: "40px", flexWrap: "wrap", fontFamily: "'Lato', sans-serif" }}>
            {["No Sign Up Required", "Real Public Data", "Zero Commitment"].map((item, index) => (
              <div key={index} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <CheckCircleIcon sx={{ color: "#00A1A1" }} />
                <span style={{ fontWeight: "600", color: "#2d3748" }}>{item}</span>
              </div>
            ))}
          </div>
          <button
            className="btn-primary btn-glitter"
            onClick={() => window.location.href = `${appFrontendUrl}/auth/live-demo`}
            style={{ padding: "16px 48px", fontSize: "1.2rem" }}
          >
            1 Click Live Demo
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default LiveDemoPromo;
